import React, { useEffect, useState } from 'react'
import AdminHeaderComponent from '../Components/AdminHeaderComponent'
import AdminDashboardMenuComponent, { AdminMenuItem } from '../Components/AdminDashboardMenuComponent'
import { adminMenuRequest } from '../Types/AdminType';
import { getAllAdminMenus } from '../Services/AdminService';
import AdminMainMenuComponent from '../Components/AdminMainMenuComponent';
import SocialSharePage from './SocialSharePage';
import AdminDashboardHeader from '../Components/AdminDashboardHeader';
import { CandidateInvitationStats, CandidateProfile } from '../../Candidate/Types/CandidateType';
import { getCandidateById } from '../../Candidate/Services/CandidateService';

function AdminDashboardPage() {


  return (
    <div>
        {/* <AdminHeaderComponent candidate={candidate}/> */}
        <AdminDashboardHeader/>
        <AdminMainMenuComponent/>
        {/* <SocialSharePage /> */}
    </div>
  )
}

export default AdminDashboardPage